export function replaceSpecialCharacters(name: string) {
  return name.replaceAll(/[-/\\^$*+?.();,|[\]{}\s]/g, '');
}
